import InfoIcon from '@svg/info-circle.svg?react';
import './info-message.scss';
import React from 'react';

type InfoMessageProps = {
    header: string;
    contentComponent: React.ComponentType<any>;
    contentProps: any;
};

export const InfoMessage: React.FC<InfoMessageProps> = ({ header, contentComponent: ContentComponent, contentProps }) => {
    return (
        <div className={'info-form'}>
            <div className={'info-icon'}>
                <InfoIcon />
            </div>
            <div className={'info-content'}>
                <div className={'info-header'}>{header}</div>
                <div className={'info-message'}>
                    <ContentComponent {...contentProps} />
                </div>
            </div>
        </div>
    );
};